// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"565":"b5fe5666","787":"e0f9b687"}[chunkId] + ".chunk.js";
};